import pbrTokenManager from '@/views/pbr/apis/manage'
import Vue from 'vue'
const pbrRouter = [{
  path: '/pbr',
  name: 'pbr',
  component: () => import('@/views/pbr/Pbr'),
  meta: {
    title: ''
  },
  beforeEnter: (to, from, next) => {
    if (!window.allToken) {
      pbrTokenManager.getSilkRoadToken()
    } else {
    }

    let queryParams = pbrTokenManager.queryURLParams(window.location.href);
    if(queryParams.userno && queryParams.userno !== ''){
      pbrTokenManager.checkFinanceUser({
        accId:queryParams.userno,
        token:queryParams.token,
        domain:queryParams.domain,
        userName:queryParams.usernickname,
        uid:queryParams.uid,
      }).then(res => {
        if (res.success) {
          pbrTokenManager.setCookie('XSRF-TOKEN-MD5', res.result._cookieToken)
          next()
        } else {
          window.location.href = window.location.origin + '/login'
        }
      })
    }else{
      pbrTokenManager.checkUserId().then(res => {
        if (res.success) {
          pbrTokenManager.setCookie('XSRF-TOKEN-MD5', res.result._cookieToken)
          next()
        } else {
          window.location.href = window.location.origin + '/login'
        }
      })
    }

    // next()
  },
  children: [{
    name: 'pbrIndex',
    path: '/pbr/index',
    component: () =>
      import('@/views/pbr/index/Index'),
    meta: {
      title: ''
    }
  },
  {
    name: 'pbrProject',
    path: '/pbr/project',
    component: () =>
        import('@/views/pbr/project/Index'),
    meta: {
      title: ''
    }
  },
  {
    name: 'pbrProjectDetail',
    path: '/pbr/project/detail',
    component: () =>
        import('@/views/pbr/project/Detail'),
    meta: {
      title: ''
    }
  },
   {
    name: 'pbrExhibitionDetail',
    path: '/pbr/exhibition/detail',
    component: () =>
        import('@/views/pbr/project/ExhibitionDetail'),
    meta: {
      title: ''
    }
  },
  {
    name: 'pbrCompanyDetail',
    path: '/pbr/company/detail',
    component: () =>
        import('@/views/pbr/project/CompanyDetail'),
    meta: {
      title: ''
    }
  },
  {
    name: 'pbrInfo',
    path: '/pbr/info',
    component: () =>
        import('@/views/pbr/info/Index'),
    meta: {
      title: ''
    }
  },
  {
    name: 'pbrInfoDetail',
    path: '/pbr/info/detail',
    component: () =>
        import('@/views/pbr/info/InfoDetail'),
    meta: {
      title: ''
    }
  },
  {
    name: 'pbrBusinessDetail',
    path: '/pbr/business/detail',
    component: () =>
        import('@/views/pbr/info/BusinessDetail'),
    meta: {
      title: ''
    }
  },
  {
    name: 'pbrRiskDetail',
    path: '/pbr/risk/detail',
    component: () =>
        import('@/views/pbr/info/RiskDetail'),
    meta: {
      title: ''
    }
  },
  {
    name: 'pbrMultilateralDetail',
    path: '/pbr/multilateral/detail',
    component: () =>
        import('@/views/pbr/info/MultilateralDetail'),
    meta: {
      title: ''
    }
  },
  {
    name: 'pbrAnalysis',
    path: '/pbr/analysis',
    component: () =>
        import('@/views/pbr/analysis/Index'),
    meta: {
      title: ''
    }
  },
  {
    name: 'pbrTopic',
    path: '/pbr/topic',
    component: () =>
        import('@/views/pbr/topic/Index'),
    meta: {
      title: ''
    }
  },
  {
    name: 'pbrTopicB',
    path: '/pbr/topic/b',
    component: () =>
        import('@/views/pbr/topic/Index2'),
    meta: {
      title: ''
    }
  },
  {
    name: 'pbrFullTopics',
    path: 'pbr/graph/full',
    component: () => import('@/views/pbr/FullTopics'),
    meta: {
      keepAlive: true
    }
  }
  ]
}]

export default pbrRouter
